// Kursfinder: zentrale Zuordnungen (Kurs-Keys aus courses.js). Fachliche Prüfung durch das Trainerteam siehe /app/memory/kursfinder_regeln.md
export const WHO = {
  einsteigen: { label: "Anfangen oder wieder einsteigen", topic: "einsteiger" },
  fitbleiben: { label: "Fit bleiben im Alltag", topic: "einsteiger" },
  "aktiv-stabil": { label: "Beweglich und stabil bleiben", topic: "einsteiger" },
  sportlich: { label: "Sportlich weiterkommen", topic: "performance" },
};

export const GOALS = [
  ["kraft", "Kraft und Fitness"],
  ["abnehmen", "Abnehmen und fitter werden"],
  ["ausdauer", "Mehr Ausdauer"],
  ["beweglichkeit", "Beweglichkeit und Ausgleich"],
  ["hyrox", "HYROX oder ATHX"],
  ["unsicher", "Noch unsicher"],
];

export const STARTS = [
  ["ruhig", "Ich fange (wieder) an – lieber sanft"],
  ["fordernd", "Ich bin regelmäßig aktiv – gern fordernd"],
  ["offen", "Irgendwo dazwischen"],
];
export const START_DEFAULT_TITLE = "Wie aktiv bist du gerade?";

// Bei HYROX/ATHX ist „ruhig“ nicht greifbar – dort fragen wir nach Erfahrung
export const STARTS_BY_GOAL = {
  hyrox: [["hyrox", "HYROX ausprobieren"], ["athx", "ATHX ausprobieren"], ["offen", "Beides – ich weiß es noch nicht"]],
};
export const START_TITLE = { hyrox: "Wo möchtest du reinschnuppern?" };

// goal -> start -> [Empfehlung, Alternative]
const RULES = {
  kraft: { ruhig: ["full body 60", "full body 30"], fordernd: ["full body 60", "hybrid"], default: ["full body 60", "bodyweight"] },
  abnehmen: { ruhig: ["full body 60", "full body 30"], fordernd: ["hybrid", "full body 60"], default: ["full body 60", "hybrid"] },
  ausdauer: { ruhig: ["hybrid", "engine"], fordernd: ["hybrid", "hyrox"], default: ["hybrid", "engine"] },
  beweglichkeit: { ruhig: ["yoga", "mobility"], fordernd: ["mobility", "body&mind"], default: ["mobility", "yoga"] },
  hyrox: { hyrox: ["hyrox", "athx"], athx: ["athx", "hyrox"], default: ["hyrox", "athx"] },
};

// "Noch unsicher" oder übersprungen: Vorschlag nach Einstiegskachel
const UNSURE = {
  einsteigen: ["full body 60", "bodyweight"],
  fitbleiben: ["full body 60", "hybrid"],
  "aktiv-stabil": ["aktiv & stabil", "full body 60"],
  sportlich: ["hybrid", "hyrox"],
  default: ["full body 60", "hybrid"],
};

const REASON = {
  kraft: "du Kraft und Fitness aufbauen möchtest",
  abnehmen: "du abnehmen und fitter werden möchtest",
  ausdauer: "du deine Ausdauer verbessern möchtest",
  beweglichkeit: "du Beweglichkeit und Ausgleich suchst",
  hyrox: "du Richtung HYROX oder ATHX trainieren möchtest",
  unsicher: "du erst einmal sehen möchtest, wie wir arbeiten – ein Ganzkörperkurs zeigt das am besten",
};
const START_SUFFIX = { ruhig: " und sanft (wieder) anfangen willst", fordernd: " und schon regelmäßig aktiv bist", offen: "" };
const START_SUFFIX_HYROX = { hyrox: " – jeder kann bei uns in jeden Kurs, dein Coach passt Gewicht und Tempo an dich an", athx: " – jeder kann bei uns in jeden Kurs, dein Coach passt Gewicht und Tempo an dich an", offen: " – starte mit HYROX, ATHX ist die Alternative; dein Coach passt alles an dein Level an" };

export const recommend = ({ who, goal, start }) => {
  const g = goal && goal !== "unsicher" ? goal : null;
  let pair = g ? (RULES[g][start] || RULES[g].default) : (UNSURE[who] || UNSURE.default);
  const suffix = g === "hyrox" ? START_SUFFIX_HYROX : START_SUFFIX;
  let reason = `Unser Vorschlag, weil ${REASON[g || "unsicher"]}${g ? suffix[start] || "" : ""}.`;

  if (who === "aktiv-stabil" && g === "ausdauer") {
    pair = start === "ruhig" ? ["aktiv & stabil", "engine"] : start === "fordernd" ? ["engine", "hybrid"] : ["engine", "aktiv & stabil"];
    reason = "Unser Vorschlag, weil du deine Ausdauer verbessern möchtest – betreut, im passenden Tempo und ohne Sprünge: Ruder-, Bike- und Gehintervalle, die dein Coach an dich anpasst.";
  } else if (who === "aktiv-stabil" && g === "beweglichkeit") {
    pair = start === "fordernd" ? ["mobility", "rückenfit"] : ["rückenfit", start === "ruhig" ? "yoga" : "mobility"];
    reason = "Unser Vorschlag, weil du Beweglichkeit und Ausgleich suchst – ein gesunder Rücken, mehr Mobilität und ein sicheres Körpergefühl im Alltag.";
  } else if (who === "aktiv-stabil" && start === "fordernd" && !g) {
    pair = ["full body 60", "aktiv & stabil"];
    reason = "Unser Vorschlag, weil du gern etwas gefordert wirst – ein Ganzkörperkurs, bei dem dein Coach Gewicht und Tempo an dich anpasst.";
  } else if (who === "aktiv-stabil" && start !== "fordernd" && (!g || g === "kraft" || g === "abnehmen")) {
    pair = ["aktiv & stabil", pair[0] === "aktiv & stabil" ? pair[1] : pair[0]];
    reason = "Unser Vorschlag, weil du es betreut und im angenehmen Tempo angehen möchtest – alltagsnah und mit Zeit für jede Übung.";
  } else if (who === "sportlich" && !g) {
    reason = "Unser Vorschlag, weil du sportlich weiterkommen möchtest – Hybrid bringt Kraft und Ausdauer zusammen, ähnlich fordernd wie ATHX und HYROX, aber der ideale Einstieg in Performance.";
  } else if (who === "sportlich" && g === "ausdauer" && start === "fordernd") {
    pair = ["hyrox", "hybrid"];
  } else if (who === "sportlich" && g === "kraft") {
    pair = start === "ruhig" ? ["kraftpur", "full body 60"] : ["kraftpur", "athx"];
    reason = "Unser Vorschlag, weil du gezielt stärker werden möchtest – strukturiertes Krafttraining mit Langhantel und freien Gewichten.";
  } else if (who === "fitbleiben" && g === "kraft" && start === "fordernd") {
    pair = ["kraftpur", "full body 60"];
    reason = "Unser Vorschlag, weil du gezielt Muskeln aufbauen und gefordert werden möchtest – strukturiertes Krafttraining mit Langhantel und freien Gewichten, Gewicht angepasst an dich.";
  } else if (who === "fitbleiben" && g === "kraft") {
    pair = ["full body 60", start === "ruhig" ? "bodyweight" : "hybrid"];
    reason = "Unser Vorschlag, weil du regelmäßig etwas für Kraft und Fitness tun möchtest – ein Ganzkörpertraining, das zu deinem Alltag passt.";
  }
  if (pair[0] === "hybrid" && g) reason = `Unser Vorschlag, weil ${REASON[g]}${suffix[start] || ""} – Hybrid verbindet Kraft und Ausdauer, ähnlich fordernd wie ATHX und HYROX, aber der perfekte Einstieg in Performance.`;
  const tip = g === "hyrox" ? { course: "hybrid", text: "Auch spannend: Hybrid – ähnliche Power wie HYROX und ATHX, aber der ideale Einstieg in Performance. Viele starten damit und wechseln später." } : null;
  const extras = g === "abnehmen";
  return { primary: pair[0], secondary: pair[1], reason, tip, extras };
};
